import { createFileRoute } from '@tanstack/react-router';
import { NotificacaoPage } from '@/features/notificacao/page/NotificacaoPage';

export const Route = createFileRoute('/a/notificacao/listagem')({
    component: NotificacaoPage,
});
